import React, { Component } from "react";
import { APIHandler, DataHandler, StorageHandler } from "C4";
import { storageKeys } from "settings";

export default class AppSettings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      appInfo: {},
    };
  }
  componentWillMount() {
    DataHandler.matchAppId().then((appId) => {
      APIHandler.getAppInfo(appId).then((res) => {
        this.setState({ appInfo: res.app[0] });
        StorageHandler.save(storageKeys.appInfo, res.app[0]);
      });
    });
  }

  render() {
    return null;
  }
}
